// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Structure__Wrapper_3_aG_","Title":"Structure__Title_36y6n"};